export default {
  contact: {
    id: '',
    legal_name: '',
    name: '',
    platform: '',
    phone: '',
    email: '',
    address: {
      city: '',
      line: '',
      postal_code: '',
      state: '',
      country: {
        country: '',
        code: '',
      },
    },
    meta_data: {
      country: {
        country: '',
        code: '',
      },
      custom_fields: {},
      notes: [],
    },
    tags: [],
  },
  contactList: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  organisationContactList: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  activityList: {
    data: [],
    links: {
      first: '',
      last: '',
      prev: '',
      next: '',
    },
    meta: {
      current_page: 1,
      from: 1,
      last_page: 1,
      path: '',
      per_page: 0,
      to: 1,
      total: 0,
    },
  },
  subscriberList: [],
  contactTagList: [],
  customFieldList: {},
  customFieldChange: {},
  conversationContactList: {},

  loadingConversationContacts: false,
  loadingContacts: false,
  loadingOrganisationContacts: false,
  subscribersLoaded: false,
  loadingContact: false,
  contactUpdated: false,
  contactDeleted: false,
  loadingActivities: false,

  loadingContactTags: true,
  contactTagCreated: false,
  contactTagUpdated: false,
  contactTagDeleted: false,
  contactTagsSynced: false,

  // organisation contacts - paged
  organisationContactPage: {
    loading: false,
    list: {
      data: [],
      links: {
        first: '',
        last: '',
        prev: '',
        next: '',
      },
      meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: '',
        per_page: 0,
        to: 1,
        total: 0,
      },
    },
  },

  loadingCustomFields: true,
  customFieldSaved: false,
  customFieldDeleted: false,
  customFieldsSynced: false,
  contactNotesSynced: false,
  importId: 0,
  importError: '',
  calculatingUniqueContacts: false,
  uniqueContactsCount: 0,
  exportId: 0,
  exportError: '',
  contactCache: {},

  apiError: {},
};
